import { render, staticRenderFns } from "./PatientDetailAction.vue?vue&type=template&id=06f42410&"
import script from "./PatientDetailAction.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports